<!-- two-factor-auth.component.html -->
<div class="d-flex flex-column flex-root h-100" id="kt_login_wrapper">
  <div class="login login-4 login-signin-on d-flex flex-row-fluid" id="kt_login">
    <div class="d-flex flex-center flex-row-fluid bgi-size-cover bgi-position-top bg-no-repeat page-bg">
      <div class="flex-column">
        <div class="login-form text-center p-7 position-relative overflow-hidden">
          <!-- Logo -->
          <div class="d-flex flex-center mb-15">
            <a href="#">
              <img alt="" class="robin-logo" src="./assets/media/logos/logo.png" />
            </a>
          </div>

          <!-- 2FA Form -->
          <div class="flex items-center justify-center grow">
            <div class="card w-75 bg-white" id="2fa_form">
              <div class="flex flex-col">
                <span class="card-header text-2sm text-gray-700 mb-1.5">
                  Enter Your Google Authenticator Code
                </span>
                <p class="card-body text-2sm text-gray-700 mb-1.5">
                  For your security, please enter the 6-digit verification code from your Google Authenticator app to continue.
                </p>
              </div>

              <form [formGroup]="twoFactorForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-5 pb-10">
                <div class="flex flex-wrap justify-center gap-2.5">
                  <input #codeInput
                         formControlName="code_0"
                         (input)="onInputChange($event, 0)"
                         (paste)="onPaste($event)"
                         class="input focus:border-primary-clarity focus:ring focus:ring-primary-clarity size-10 shrink-0 px-0 text-center"
                         maxlength="1"
                         type="text"
                         inputmode="numeric">
                  <!-- Repeat for other 5 inputs -->
                  <input #codeInput
                         formControlName="code_1"
                         (input)="onInputChange($event, 1)"
                         class="input focus:border-primary-clarity focus:ring focus:ring-primary-clarity size-10 shrink-0 px-0 text-center"
                         maxlength="1"
                         type="text"
                         inputmode="numeric">
                  <input #codeInput
                         formControlName="code_2"
                         (input)="onInputChange($event, 2)"
                         class="input focus:border-primary-clarity focus:ring focus:ring-primary-clarity size-10 shrink-0 px-0 text-center"
                         maxlength="1"
                         type="text"
                         inputmode="numeric">
                  <input #codeInput
                         formControlName="code_3"
                         (input)="onInputChange($event, 3)"
                         class="input focus:border-primary-clarity focus:ring focus:ring-primary-clarity size-10 shrink-0 px-0 text-center"
                         maxlength="1"
                         type="text"
                         inputmode="numeric">
                  <input #codeInput
                         formControlName="code_4"
                         (input)="onInputChange($event, 4)"
                         class="input focus:border-primary-clarity focus:ring focus:ring-primary-clarity size-10 shrink-0 px-0 text-center"
                         maxlength="1"
                         type="text"
                         inputmode="numeric">
                  <input #codeInput
                         formControlName="code_5"
                         (input)="onInputChange($event, 5)"
                         class="input focus:border-primary-clarity focus:ring focus:ring-primary-clarity size-10 shrink-0 px-0 text-center"
                         maxlength="1"
                         type="text"
                         inputmode="numeric">
                  <!-- ... up to code_5 -->
                </div>

                <div class="flex flex-wrap justify-center gap-2.5">
                    <a routerLink="/auth/login" class="btn btn-icon2 btn-light btn-hover-info btn-sm my-auto">
                    <span [inlineSVG]="'./assets/media/svg/icons/Code/reply.svg'"
                          class="svg-icon svg-icon-info "></span>
                    Back to Login &nbsp;
                  </a>
                  <button type="submit"
                          class="btn btn-icon2 btn-primary btn-hover-light btn-sm my-auto" [disabled]="isLoading">
                    <span [inlineSVG]="'./assets/media/svg/icons/Code/done.svg'"
                          class="svg-icon svg-icon-light "></span>
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm"></span>
                    {{ isLoading ? 'Verifying...' : 'Verify Code' }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
